module.exports = {
  // BACKEND_URL: "https://sdscoep.com/sdsportal/api"
  // BACKEND_URL: "https://sdscoep.club/sdsportal/api/",
  BACKEND_URL: "/api",
};
